'use strict'

function leftPad(value) {
  if (value >= 10) {
    return value
  }
  return `0${value}`
}

function toYYYY_MM_DD(source, delimiter = '-') {
  const year = source.getFullYear()
  const month = leftPad(source.getMonth() + 1)
  const day = leftPad(source.getDate())
  return [year, month, day].join(delimiter)
}

function toHH_MM(source) {
  const hour = leftPad(source.getHours())
  const minute = leftPad(source.getMinutes())
  return [hour, minute].join(':')
}

const dateOrHour = (timeStamp) => {
  const now = new Date(Date.now())
  const past = new Date(_.toNumber(timeStamp))
  if (
    now.getMonth() === past.getMonth() &&
    now.getDate() === past.getDate() &&
    now.getFullYear() === past.getFullYear()
  ) {
    return toHH_MM(past)
  }
  return toYYYY_MM_DD(past)
}

const date = (timeStamp) => {
  const past = new Date(_.toNumber(timeStamp))
  return toYYYY_MM_DD(past)
}

const getProject = (data) => {
  if (!data) return {}
  const {
    fileName,
    type,
    tab,
    projectName,
    projectNames,
    projectNameEn,
    projectNameKo,
    image,
    youtube,
    circuit
  } = data
  const project = {
    fileName,
    type
  }
  if (type === 'sample') {
    if (projectNames) project.projectNames = projectNames
    else {
      project.projectNames = {
        en: projectNameEn,
        ko: projectNameKo
      }
    }
    project.tab = tab
  } else project.projectName = projectName
  if (image) project.image = image
  if (youtube) project.youtube = youtube
  if (circuit) project.circuit = circuit
  return project
}

const getProjectData = (project) => {
  if (!project) return {}
  const data = {
    fileName: project.fileName,
    type: project.type
  }
  if (project.type === 'sample') {
    data.projectNameEn = _.get(project, 'projectNames.en', '')
    data.projectNameKo = _.get(project, 'projectNames.ko', '')
    data.tab = project.tab
    const image = _.get(project, 'image')
    const youtube = _.get(project, 'youtube')
    const circuit = _.get(project, 'circuit')
    if (image) data.image = image
    if (youtube) data.youtube = youtube
    if (circuit) data.circuit = circuit
  } else {
    data.projectName = project.projectName
  }
  return data
}

const getProjectName = (project, language) => {
  if (!project) return ''
  const { projectName, projectNames, type } = project
  if (type === 'sample') {
    let ret = _.get(projectNames, 'en', '')
    if (_.get(projectNames, language)) ret = _.get(projectNames, language, '')
    return ret
  } else {
    return projectName
  }
}

export default {
  dateOrHour,
  date,
  getProject,
  getProjectData,
  getProjectName
}
